// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DuhPz","left":"styles_left__39vv7"};